import { ItemCategoryCreateForm } from "@/features/itemCategory/form/CreateForm";
import { ItemCategoryTable } from "@/features/itemCategory/table";
import { useModal } from "@/features/modal/ModalStackManager";
import { ActionHeader } from "@/features/standard/ActionHeader";
import { Header } from "@/features/standard/Header";
import { Main } from "@/features/standard/Main";
import { HeaderSubTitle } from "@/features/standard/SubTitle";
import { HeaderTitle } from "@/features/standard/Title";
import { Wrapper } from "@/features/standard/Wrapper";
import { usePub } from "@/hooks";
import { Button } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";

const ItemCategory = Object.assign({}, Main, {
  Header: Header,
  HeaderTitle: HeaderTitle,
  HeaderSubTitle: HeaderSubTitle,
  Wrapper: Wrapper,
  ActionHeader: ActionHeader,
  ActionButton: Button,
  CreateForm: ItemCategoryCreateForm,
});

export const ItemCategoryPage = () => {
  const { openModal } = useModal();

  const publish = usePub();

  return (
    <ItemCategory.Wrapper>
      <ItemCategory.ActionHeader>
        <ItemCategory.ActionButton
          leftIcon={<IconPlus />}
          onClick={() =>
            openModal(<ItemCategory.CreateForm />, null, "품목분류 추가", true)
          }
        >
          추가
        </ItemCategory.ActionButton>
        <ItemCategory.ActionButton
          color="red"
          rightIcon={<IconTrash />}
          onClick={() => publish("deleteSelectedItems")}
        >
          선택된 행 삭제
        </ItemCategory.ActionButton>
      </ItemCategory.ActionHeader>
      <ItemCategory.Header>
        <ItemCategory.HeaderTitle>품목분류</ItemCategory.HeaderTitle>
        <ItemCategory.HeaderSubTitle>
          우리 회사에서 다루는 품목분류에 대해 조회할 수 있는 페이지 입니다.
        </ItemCategory.HeaderSubTitle>
      </ItemCategory.Header>
      <ItemCategoryTable />
    </ItemCategory.Wrapper>
  );
};
